/**
 * In-memory access token with localStorage persistence.
 * The refresh token itself is stored server-side in an httpOnly cookie,
 * so we never read it from JavaScript. We keep a copy as a fallback
 * in localStorage in case the browser blocks third-party cookies when
 * the frontend and backend are hosted on different origins.
 */

const ACCESS_TOKEN_KEY = 'bds.accessToken';
const REFRESH_TOKEN_KEY = 'bds.refreshToken';

export const tokenStore = {
  getAccessToken(): string | null {
    try {
      return localStorage.getItem(ACCESS_TOKEN_KEY);
    } catch {
      return null;
    }
  },
  setAccessToken(token: string | null) {
    try {
      if (token) {
        localStorage.setItem(ACCESS_TOKEN_KEY, token);
      } else {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
      }
    } catch {
      // ignore storage errors
    }
  },
  getRefreshToken(): string | null {
    try {
      return localStorage.getItem(REFRESH_TOKEN_KEY);
    } catch {
      return null;
    }
  },
  setRefreshToken(token: string | null) {
    try {
      if (token) {
        localStorage.setItem(REFRESH_TOKEN_KEY, token);
      } else {
        localStorage.removeItem(REFRESH_TOKEN_KEY);
      }
    } catch {
      // ignore storage errors
    }
  },
  clear() {
    this.setAccessToken(null);
    this.setRefreshToken(null);
  }
};
